import { render, staticRenderFns } from "./read.vue?vue&type=template&id=d49888ca&"
import script from "./read.vue?vue&type=script&lang=js&"
export * from "./read.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports